var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBTeamPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-team-plus",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.817,15.631c-3.351,0.004 -6.459,1.793 -8.135,4.695c-0.17,0.325 -0.51,0.547 -0.901,0.547c-0.56,-0 -1.015,-0.455 -1.015,-1.015c-0,-0.201 0.059,-0.389 0.16,-0.547c1.334,-2.309 3.408,-4.039 5.823,-4.96c-1.819,-1.279 -3.01,-3.394 -3.01,-5.785c0,-3.9 3.166,-7.066 7.066,-7.066c3.9,0 7.066,3.166 7.066,7.066c-0,3.895 -3.16,7.058 -7.054,7.065Zm-0.012,-2.028c0.003,-0 0.005,-0.001 0.008,-0.001c0,0 0.003,0 0.004,0c2.774,-0.006 5.024,-2.261 5.024,-5.036c0,-2.78 -2.256,-5.037 -5.036,-5.037c-2.78,0 -5.037,2.257 -5.037,5.037c0,2.779 2.257,5.037 5.037,5.037Zm-7.78,-10.018c-0.005,0.002 -0.017,0.007 -0.017,0.007c-1.627,0.802 -2.746,2.47 -2.746,4.398c0,1.415 0.887,2.767 1.668,3.631c0.095,0.106 0.414,0.414 0.649,0.791c0.148,0.239 0.264,0.507 0.256,0.767c-0.009,0.261 -0.2,0.534 -0.437,0.783c-0.377,0.397 -0.878,0.73 -1.055,0.848c-0.717,0.48 -1.828,1.386 -2.469,2.341l-0.005,0.007c-0.161,0.289 -0.463,0.491 -0.819,0.51c-0.549,0.03 -1.019,-0.39 -1.049,-0.936c-0.01,-0.192 0.036,-0.375 0.123,-0.532c0,-0 0.042,-0.069 0.051,-0.082c0.843,-1.277 1.973,-2.335 3.295,-3.093l0.138,-0.079l-0.131,-0.09c-1.021,-0.699 -2.251,-2.753 -2.251,-4.869c0,-2.889 1.78,-5.365 4.309,-6.403c0.021,-0.008 0.04,-0.016 0.061,-0.024c0.17,-0.067 0.405,-0.06 0.449,-0.06c0.494,0.048 0.945,0.443 0.928,0.948c-0.011,0.317 -0.164,0.56 -0.343,0.738c-0.249,0.249 -0.547,0.376 -0.605,0.399Zm12.975,14.915l0,-2c0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1l0,2l2,0c0.552,0 1,0.448 1,1c0,0.552 -0.448,1 -1,1l-2,0l0,2c0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1l0,-2l-2,0c-0.552,0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1l2,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBTeamPlus);
export default __webpack_public_path__ + "static/media/iconB-team-plus.fdd696ac4f0f24f749e43f1cac52d746.svg";
export { ForwardRef as ReactComponent };